import React from "react";

import { BrowserRouter as Router } from "react-router-dom";

import AppRoutes from "app/router";
import { GlobalAlertProvider } from "shared/ui/feedback";

function App() {
  const allowDebugConsole = process.env.REACT_APP_DEBUG_CONSOLE === "true";
  if (process.env.NODE_ENV === "production" && !allowDebugConsole) {
    window.console = {
      log: function () {},
      warn: function () {},
      error: function () {},
    };
  }

  return (
    <Router>
      <GlobalAlertProvider>
        <AppRoutes />
      </GlobalAlertProvider>
    </Router>
  );
}

export default App;
